"use client"

import { useTranslations } from "next-intl"

import { ArrowDisc } from "@/components/ui"

const DISC = "pointer-events-auto absolute z-10"

interface RailArrowsProps {
  atStart: boolean
  atEnd: boolean
  onPage: (direction: 1 | -1) => void
  top: string
  tone?: "brand" | "inverse"
}

export const RailArrows = ({ atStart, atEnd, onPage, top, tone = "brand" }: RailArrowsProps) => {
  const t = useTranslations("marketplace.product")
  return (
    <div className="max-w-page pointer-events-none absolute inset-y-0 left-0 w-full">
      {!atStart && <ArrowDisc direction="previous" tone={tone} aria-label={t("previous")} onClick={() => onPage(-1)} className={`${DISC} ${top} left-250 @3xl:left-875`} />}
      {!atEnd && <ArrowDisc direction="next" tone={tone} aria-label={t("next")} onClick={() => onPage(1)} className={`${DISC} ${top} right-250 @3xl:right-1.75`} />}
    </div>
  )
}
